import { IconProps } from '../types';

function ViewListQuestionSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'h-5 w-5'}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M3 4c0-.6.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h7c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm0 4c0-.6.4-1 1-1h7c.6 0 1 .4 1 1s-.4 1-1 1H4c-.6 0-1-.4-1-1zm12-7c-.4 0-.7.2-.9.5-.3.5-.9.6-1.4.4-.5-.3-.6-.9-.4-1.4.6-.9 1.6-1.5 2.7-1.5 1.7 0 3 1.3 3 3 0 1.3-.8 2.4-2 2.8v.2c0 .6-.4 1-1 1s-1-.4-1-1v-1c0-.6.4-1 1-1s1-.4 1-1-.4-1-1-1zm0 8c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ViewListQuestionSolidIcon;
